<script setup lang="ts">
import { COLOR_CLASSES } from '@/constants/colors';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';

interface Props {
  cancelText?: string;
  confirmText?: string;
  isLoading?: boolean;
  disabled?: boolean;
  showCancel?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  cancelText: '취소',
  confirmText: '확인',
  disabled: false,
  showCancel: true,
  isLoading: false,
});

const emit = defineEmits<{
  (e: 'cancel'): void;
  (e: 'confirm'): void;
}>();
</script>

<template>
  <div class="flex justify-between w-full gap-3">
    <button
      v-if="showCancel"
      type="button"
      class="w-[39%] h-[50px] bg-white border font-bold rounded-[6px]"
      :class="[COLOR_CLASSES.text.orange, { '!border-primary-500': !disabled }]"
      :disabled="isLoading"
      @click="emit('cancel')"
    >
      {{ cancelText }}
    </button>
    <button
      type="button"
      :class="[
        showCancel ? 'w-[57%]' : 'w-full',
        'h-[50px] text-white font-bold rounded-[6px]',
        disabled ? 'bg-primary-500 opacity-50 cursor-not-allowed' : 'bg-primary-500 hover:bg-[#d67a3d]',
      ]"
      :disabled="disabled || isLoading"
      @click="emit('confirm')"
    >
      <LoadingSpinner v-if="isLoading" text="처리중..." show-text />
      <span v-else>{{ confirmText }}</span>
    </button>
  </div>
</template>
